// Built-ins
import React from "react";

// Custom Made Components
import ConsultantOverview from "./consultant_overview/consultant_overview";

function Consultant() {
  return <ConsultantOverview />;
}

export default Consultant;
